/**
 * Blob URL ↔ base64 変換ユーティリティ
 * 旧: @/mixins/blob-utils （Gate A: @/mixins/* import 禁止のため移動）
 */

/** BlobをBase64 data URLに変換 */
function blobToBase64(blob: Blob): Promise<string> {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()
    reader.onloadend = function () {
      resolve(reader.result as string)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

/** blob: URLをfetchしてbase64に変換 */
export function fetchBlobUrlAsBase64(blobUrl: string): Promise<string> {
  return fetch(blobUrl)
    .then(function (res) {
      return res.blob()
    })
    .then(function (blob) {
      return blobToBase64(blob)
    })
}

/** HTML文字列内のすべてのblob: URLをbase64に並列変換 */
export async function convertBlobUrlsToBase64(html: string): Promise<string> {
  const blobUrlRegex = /blob:[^"'\s]+/g
  const matches = html.match(blobUrlRegex)

  if (!matches) return html

  const uniqueUrls = [...new Set(matches)]

  const conversions = uniqueUrls.map(async function (blobUrl) {
    try {
      const base64 = await fetchBlobUrlAsBase64(blobUrl)
      return { blobUrl, base64 }
    } catch (e) {
      console.warn('[blobUtils] Blob URL変換失敗:', blobUrl, e)
      return null
    }
  })

  const results = await Promise.all(conversions)
  let result = html
  results.forEach(function (item) {
    if (item) {
      result = result.replaceAll(item.blobUrl, item.base64)
    }
  })
  return result
}
